import { jsxs as d, jsx as c } from "react/jsx-runtime";
import { Field as p, Switch as x, Label as h } from "@headlessui/react";
import { twMerge as e } from "tailwind-merge";
const N = ({
  switcherElement: n,
  selected: r,
  onChange: t,
  label: i,
  labelClassName: m,
  wrapperClassName: l,
  switcherClassName: f,
  disabled: o,
  dataTestId: a
}) => /* @__PURE__ */ d(
  p,
  {
    className: e(
      "relative flex flex-col gap-2 md:flex-row md:items-center",
      l
    ),
    children: [
      /* @__PURE__ */ c(
        x,
        {
          checked: r,
          disabled: o,
          onChange: t,
          onKeyDown: (s) => {
            s.key === "Enter" && !o && (s.preventDefault(), t(!r));
          },
          className: e("focus-ring inline-flex w-fit shrink-0 rounded-sm", f),
          "data-test-id": a,
          children: n
        }
      ),
      i && /* @__PURE__ */ c(h, { className: e("cursor-pointer", m), children: i })
    ]
  }
);
export {
  N as BaseSwitcher
};
